// Burger King CSS

import { LayoutWidth, ZIndex } from './enums';
// Burger King 2020 Legacy Visual Identity

export const cssConstants = {
  // Extra CSS Properties
  borderRadius: '10px',

  boxShadow: '0 0 4px 0 rgba(73, 73, 73, 0.2)',
  shadowColor: 'rgba(73, 73, 73, 0.2)',
  shadowOffset: '0',
  shadowRadius: '4px',

  // Color Styles
  color: {
    accent: '#af0c2a',
    alert: {
      default: {
        background: '#502314',
        text: '#ffffff',
      },
      info: {
        background: '#FF8732',
        text: '#ffffff',
      },
      success: {
        background: '#1B8737',
        text: '#ffffff',
      },
      warning: {
        background: '#D62300',
        text: '#ffffff',
      },
      error: {
        background: '#D62300',
        text: '#ffffff',
      },
      dark: {
        background: '#000000',
        text: '#ffffff',
      },
    },
    codeBlockBackground: '#F5EBDC',
    contrastBackground: '#502314',
    error: '#D62300',
    errorHover: '',
    pricing: '#502314',
    validated: '#1b8737',
    validatedHover: '',
    primary: '#D62300',
    primaryHover: '#a71b00',
    secondary: '#D62300',
    secondaryHover: '#a71b00',
    teal: '',
    tertiary: '#502314',
    background: '#F5EBDC',
    loyaltyHighlight: '',
    navLinkColor: {
      active: '#D62300',
      hover: '#a71b00',
    },
    mobileNavButtonColor: '#502314',
    black: '#502314',
    icon: '#D62300',
    grey: {
      one: '#2b0200',
      two: '#9f816f',
      three: '#693f34',
      four: '#bba391',
      five: '#d7c7b5',
      six: '#845f50',
      seven: '#340000',
      eight: '#4e201d',
      nine: '',
      ten: '',
    },
    headerContrast: '#D62300',
    highlight: '',
    white: '#F5EBDC',
    cardBackground: '#fff',
    dialogBackground: '#fff',
    disabledBorder: '#d4c7b7',
    disabledBackground: '',
    disabledColor: '#d4c7b7',
    success: '',
    red: '#d62300',
    green: '#338e53',
    orange: '#fe8731',
  },

  // Font Styles
  fontFamily: {
    base: 'Flame, "Cooper Black", "Helvetica Neue", Helvetica, Arial, sans-serif',
    body: '"Flame Sans", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',
    alternative: '"Flame Bold", "Helvetica Neue", Helvetica, Arial, Verdana, sans-serif',
    brand: 'Flame, "Cooper Black", "Helvetica Neue", Helvetica, Arial, sans-serif',
  },

  // Font Weight Styles
  fontWeight: {
    black: 800,
    heavy: 'bold',
    normal: 'normal',
    light: 'normal',
  },

  // Font Transforms Styles
  textTransform: {
    headlines: 'none',
    body: 'none',
  },

  // Z Index Styles
  zIndex: {
    min: ZIndex.MIN,
    max: ZIndex.MAX,
    overlay: ZIndex.OVERLAY,
    desktopHeader: ZIndex.DESKTOP_HEADER,
    top: ZIndex.TOP,
    normal: ZIndex.NORMAL,
    below: ZIndex.BELOW,
  },

  // Layout variables
  layout: {
    sectionMaxWidth: `${LayoutWidth.REGULAR}px`,
    smallerSectionMaxWidth: `${LayoutWidth.SMALL}px`,
    checkoutHeaderHeight: '57px',
    navHeight: {
      mobile: '56px',
      desktop: '78px',
    },
  },
};
